export default __webpack_public_path__ + "static/media/a017-market-1.fd914aeb.svg";